export enum BidIntentButtonTrigger {
    VIEW_ONLY_INTENT_TRIGGER = '',
    IM_OUT_INTENT_TRIGGER = 'gtm-im-out-trigger',
    MAY_BID_INTENT_TRIGGER = 'gtm-may-bid-trigger'
}
